<template>
  <el-dialog
    append-to-body
    width="600px"
    :title="`用工单位: ${curRow.company_name}`"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div>选择您要导出的字段</div>
    <el-checkbox
      style="margin-top: 10px; margin-bottom: 10px; display: block"
      :indeterminate="isIndeterminate"
      v-model="checkAll"
      @change="handleCheckAllChange"
      >全选</el-checkbox
    >
    <el-checkbox-group
      v-model="checkedCities"
      @change="handleCheckedCitiesChange"
    >
      <el-checkbox
        style="width: 25%"
        v-for="item in titleArr"
        :label="item.value"
        :key="item.value"
        :disabled="item.value == 'employee_name'"
        >{{ item.label }}</el-checkbox
      >
    </el-checkbox-group>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button type="primary" @click="confirm">确定导出</el-button>
        <el-button @click="toggle(false)">取消</el-button>
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
import { exportData } from "@/util";
export default {
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      loading: false,
      curRow: {},
      titlesObj: {},
      titleArr: [],
      checkAll: false,
      isIndeterminate: false,
      checkedCities: [],
    };
  },
  methods: {
    handleCheckAllChange(val) {
      this.checkedCities = val ? this.titleArr.map((i) => i.value) : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.titleArr.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.titleArr.length;
    },
    // 获取详情
    getDetail(row) {
      this.curRow = row;
      this.getFields();
    },
    getFields() {
      let _params = {
        id: this.curRow.id,
        page: 1,
        count: 10,
      };
      this.$http
        .get("/admin/finance/preview", { params: _params })
        .then((res) => {
          if (res.code === 1) {
            this.titlesObj = res.data.titles;
            let entries = Object.entries(this.titlesObj);
            this.titleArr = entries.map((item) => {
              return {
                label: item[0],
                value: item[1],
              };
            });
            console.log(this.titleArr, "this.titleArr");
            this.checkedCities = ["employee_name"];
          }
        });
    },
    reset(done) {
      this.checkAll = false;
      this.isIndeterminate = false;
      this.checkedCities = [];
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    confirm() {
      this.$confirm("请确认操作？", "提示", {
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            let fields = this.checkedCities.map((item) => {
              let obj = this.titleArr.find((i) => i.value === item);
              return {
                key: obj.label,
                value: obj.value,
              };
            });
            exportData(
              { id: this.curRow.id, fields: JSON.stringify(fields) },
              "/admin/finance/exportFields"
            );
            this.toggle(false);
            done();
          } else {
            done();
          }
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.dialog-wrap {
  text-align: center;
  p {
    margin: 20 auto;
  }
  .company-name {
    margin-bottom: 20px;
  }
}
::v-deep {
  .el-form-item {
    margin-bottom: 6px;
  }
}
</style>